import { NavLink } from "react-router-dom";
import { services } from "../../../../globals/neuron-content";

function SectionServices2() {
  return (
    <div className="section-full p-t110 p-b80 sx-why-choose-outer sx-bg-light">
      <div className="container">
        <div className="section-head center">
          <div className="sx-head-s-title">Core Services</div>
          <div className="sx-head-l-title"><h2 className="sx-title">Security and Protection Services</h2></div>
        </div>
        <div className="section-content">
          <div className="owl-carousel sx-why-choose-carousel m-b30">
            {services.map((service) => (
              <div className="item" key={service.title}>
                <div className="sx-icon-bx-4">
                  <div className="sx-icon-box-wraper">
                    <div className="sx-icon-bx-icon "><span className="sx-text-primary"><i className={service.icon} /></span></div>
                    <div className="icon-content">
                      <NavLink to={`/services/${service.slug}`}><h4 className="sx-tilte">{service.title}</h4></NavLink>
                      <NavLink to={`/services/${service.slug}`} className="sx-why-ch-category">{service.category}</NavLink>
                      <p>{service.summary}</p>
                      <NavLink className="sx-circle-btn" to={`/services/${service.slug}`}><i className="fa fa-long-arrow-right" /></NavLink>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionServices2;
